import { render } from "./SummaryBoxRow.vue?vue&type=template&id=37e180d8&scoped=true"
import script from "./SummaryBoxRow.vue?vue&type=script&lang=js"
export * from "./SummaryBoxRow.vue?vue&type=script&lang=js"

import "./SummaryBoxRow.vue?vue&type=style&index=0&id=37e180d8&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e180d8"]])

export default __exports__